var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgYieldPen = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.35 2.6h4.3l2.15 3.75-2.15 3.75h-4.3L3.2 6.35 5.35 2.6zm.72 1.25L4.64 6.35l1.43 2.5h2.86l1.43-2.5-1.43-2.5H6.07z",
    fill: "#494C5B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.35 10.6h4.3l2.15 3.75-2.15 3.75h-4.3L1.2 14.35l2.15-3.75zm.72 1.25l-1.43 2.5 1.43 2.5h2.86l1.43-2.5-1.43-2.5H4.07z",
    fill: "#494C5B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.62 6.02a.83.83 0 0 0-.24-.59l-1.98-1.98a.83.83 0 0 0-1.18 0l-1.32 1.32-5.1 5.1a.83.83 0 0 0-.24.59v1.98c0 .46.37.83.83.83h1.98a.83.83 0 0 0 .59-.24l5.1-5.1 1.32-1.32a.83.83 0 0 0 .24-.59zm-7.58 5.83H9.98v-1.06l4.63-4.63 1.32 1.32-4.89 4.37zm5.55-5.29-1.32-1.32.66-.66 1.32 1.32-.66.66z",
    fill: "#494C5B"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgYieldPen);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/yieldPen.58cbabcb472742663e440240fcabe182.svg";